export type PreviewPage = {
  src: string;
  alt: string;
};

export const previewPages: PreviewPage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/w85P7sSNsY9r1xMaAk11GQ/IMG_2782.jpg',
    alt: 'Volume 01 cover: Fluid Power Fundamentals — Principles, Components & Circuit Symbols, showing a hydraulic press, power unit and pneumatic valve bank',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/8aDr1mxTdMEKd7jqXb1sE2/IMG_2783.jpg',
    alt: 'Sample page Fluid Power Transmits Energy Through a Fluid, showing mechanical input, fluid transmission and mechanical output',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/v8kNhJ6r6MhvsDYvnvWd8x/IMG_2784.jpg',
    alt: 'Sample page Every System Has the Same Building Blocks, an annotated anatomy of a hydraulic system with ten labelled components',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/eszY8jzQQTSe3tsA41n9uz/IMG_2785.jpg',
    alt: 'Sample page Compressing Air Heats It. Cooling It Makes Water, explaining heat of compression, condensation and pressure dew point',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/6GAdnQB2ofZcPhr5cXAUko/IMG_2786.jpg',
    alt: 'Sample page See the Pressure: Gauges and Test Points, covering gauge range, test points and snubbers',
  },
];
